export const getConfluenceHomeUrl = (): string =>
	`${window.location.protocol}//${window.location.host}/wiki`;

export const getCurrentUrl = (): string =>
	`${window.location.protocol}//${window.location.host}${window.location.pathname}${window.location.search}`;

export const getCurrentUrlRedirect = () =>
	`${getConfluenceHomeUrl()}?continue=${encodeURIComponent(getCurrentUrl())}`;
